module.exports = __webpack_public_path__ + "static/media/Michelhausen.14b6d2cc.webp";